var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/ugc-tile-macro.j2"] = require( "macros/ugc-tile-macro.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["contentful/ugc-pdp-module-header.j2"] = require( "contentful/ugc-pdp-module-header.j2" );
dependencies["contentful/ugc-pdp-carousel.j2"] = require( "contentful/ugc-pdp-carousel.j2" );
dependencies["contentful/pdp-ugc-banner.j2"] = require( "contentful/pdp-ugc-banner.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-pdp-module-content.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/ugc-tile-macro.j2", false, "core/templates/contentful/ugc-pdp-module-content.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayUgcTile")) {
var t_4 = t_1.displayUgcTile;
} else {
cb(new Error("cannot import 'displayUgcTile'")); return;
}
context.setVariable("displayUgcTile", t_4);
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/contentful/ugc-pdp-module-content.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("categoryUrl")) {
var t_8 = t_5.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_8);
var t_9;
t_9 = (lineno = 3, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ugc.0.items",[]]));
frame.set("ugcItems", t_9, true);
if(frame.topLevel) {
context.setVariable("ugcItems", t_9);
}
if(frame.topLevel) {
context.addExport("ugcItems", t_9);
}
if((lineno = 5, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ugc.0.isEngage",false]))) {
output += "\n\n    ";
output += "\n\n    <div class=\"dom-ugc js-ugc\" data-qa-ugc=\"0\" data-index=\"0\" ";
output += runtime.suppressValue((lineno = 10, colno = 73, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga_inview"), "ga_inview", context, ["PAGE_TYPE","ugc_viewed","UGC PDP",{"dy_noninteraction": 1}])), env.opts.autoescape);
output += ">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugcItems")),"length") > 0) {
env.getTemplate("contentful/ugc-pdp-module-header.j2", false, "core/templates/contentful/ugc-pdp-module-content.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n            ";
env.getTemplate("contentful/ugc-pdp-carousel.j2", false, "core/templates/contentful/ugc-pdp-module-content.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
})})})});
}
output += "</div>\n\n";
;
}
else {
output += "\n\n    <div class=\"dom-ugc js-ugc\" data-qa-ugc=\"0\" data-index=\"0\" ";
output += runtime.suppressValue((lineno = 24, colno = 73, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga_inview"), "ga_inview", context, ["PAGE_TYPE","ugc_viewed","UGC PDP",{"dy_noninteraction": 1}])), env.opts.autoescape);
output += ">";
if((lineno = 26, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.ugcOptions.pdp.show_heading"]))) {
env.getTemplate("contentful/ugc-pdp-module-header.j2", false, "core/templates/contentful/ugc-pdp-module-content.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
})});
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugcItems")),"length") > 0) {
output += "<div class=\"o-row c-ugc-pdp\">\n\n                <div class=\"o-column o-extra-small--12 o-large--6 u-centered-content\">\n\n                    ";
env.getTemplate("contentful/pdp-ugc-banner.j2", false, "core/templates/contentful/ugc-pdp-module-content.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
output += "\n\n                </div>\n\n                <div class=\"o-column o-extra-small--12 o-large--6\">\n\n                    ";
env.getTemplate("contentful/ugc-pdp-carousel.j2", false, "core/templates/contentful/ugc-pdp-module-content.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
output += t_27
output += "\n\n                </div>\n\n            </div>";
})})})});
}
else {
output += "<div class=\"o-row c-ugc-pdp\">\n\n                <div class=\"o-column o-extra-small--12 o-large--6 o-large--centered u-centered-content\">\n\n                    ";
env.getTemplate("contentful/pdp-ugc-banner.j2", false, "core/templates/contentful/ugc-pdp-module-content.j2", null, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
t_30.render(context.getVariables(), frame, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
output += t_31
output += "\n\n                </div>\n\n            </div>";
})});
}
output += "</div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-pdp-module-content.j2"] , dependencies)